const lang = {

 en: {
    search: "Search",
    gptSearchPlaceHolder: "What do you like to watch today?",

 },

 hindi: {
    search: "खोज",
    gptSearchPlaceHolder: "आज आप क्या देखना पसंद करेंगे?",
 },

 spanish: {
    search: "buscar",
    gptSearchPlaceHolder: "¿Qué te gusta ver hoy?",
 }



}

export default lang;